import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "squares-2-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { stroke: "currentColor", strokeWidth: 1.5, fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M14.25 6.25v7a1 1 0 01-1 1h-7a1 1 0 01-1-1v-2.5h4.5a1 1 0 001-1v-4.5h2.5a1 1 0 011 1z", fillOpacity: 0.15, fill: "currentColor" }),
        React.createElement("path", { d: "M10.75 2.75v7a1 1 0 01-1 1h-7a1 1 0 01-1-1v-7a1 1 0 011-1h7a1 1 0 011 1z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
